import React, { useState } from "react";
import { Text, Button } from "@shopify/polaris";

const DEFAULT_MAX_LENGTH = 100;

/**
 * Renders a note that automatically truncates if longer than maxLength.
 * Shows a "See full note" button for long notes.
 */
export function TruncatedNote({
  note,
  maxLength = DEFAULT_MAX_LENGTH,
}: {
  note: string | null | undefined;
  maxLength?: number;
}) {
  const [expanded, setExpanded] = useState(false);
  const text = note?.trim() || "No note";

  if (text.length <= maxLength) {
    return (
      <div style={{ maxWidth: "220px", whiteSpace: "normal" }}>
        <Text variant="bodySm" tone="subdued" as="span">
          {text}
        </Text>
      </div>
    );
  }

  if (expanded) {
    return (
      <div style={{ maxWidth: "220px", whiteSpace: "normal" }}>
        <Text variant="bodySm" tone="subdued" as="span">
          {text}
        </Text>
        <div style={{ marginTop: "2px" }}>
          <Button
            variant="plain"
            size="slim"
            onClick={() => setExpanded(false)}
          >
            Show less
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: "220px", whiteSpace: "normal" }}>
      <Text variant="bodySm" tone="subdued" as="span">
        {text.substring(0, maxLength)}…
      </Text>
      <div style={{ marginTop: "2px" }}>
        <Button
          variant="plain"
          size="slim"
          onClick={() => setExpanded(true)}
        >
          See full note
        </Button>
      </div>
    </div>
  );
}
